import React from 'react';
import { Row, Col } from 'antd';
import CustomInput from '../../../../../../components/CustomInput';

export default function DetailsGeneralInputs({ onChange, data, errors }) {
    return (
        <>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Name
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell details-table__cell--editable">
                            <CustomInput
                                className="input-dark"
                                id="name"
                                placeholder="Enter client name"
                                onInputChange={onChange}
                                inputValue={data?.name}
                                width="100%"
                                errorText={errors?.name}
                            />
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            ClientID
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell details-table__cell--editable">
                            <CustomInput
                                className="input-dark"
                                id="client_uid"
                                placeholder="Enter client ID"
                                onInputChange={onChange}
                                inputValue={`${data?.client_uid}`}
                                width="100%"
                                errorText={errors?.client_uid}
                            />
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            API URL
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell details-table__cell--editable">
                            <CustomInput
                                className="input-dark"
                                id="api_url"
                                placeholder="Enter API URL"
                                onInputChange={onChange}
                                inputValue={data?.api_url}
                                width="100%"
                                errorText={errors?.api_url}
                            />
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            CRM URL
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell details-table__cell--editable">
                            <CustomInput
                                className="input-dark"
                                id="crm_url"
                                placeholder="Enter CRM URL"
                                onInputChange={onChange}
                                inputValue={data?.crm_url}
                                width="100%"
                                errorText={errors?.crm_url}
                            />
                        </div>
                    </Col>
                </Row>
            </div>
        </>
    );
}
